module.exports = __webpack_public_path__ + "img/02.00b42106.png";